import { useEffect } from 'react'
import { Helmet } from 'react-helmet'
import packageJson from '../package.json'
import { BrowserRouter as Router, Route, Routes, Navigate, Link } from 'react-router-dom'
import { Login, Dashboard, EntryForm } from './Pages'
import authService from './Services/auth'
import * as loginActions from './redux/actions/login.action'
import { Alive, Ready } from './component/HealthCheck'
import { useDispatch, useSelector } from 'react-redux'
import { RootReducers } from './redux/reducers'
import { Summary } from './Pages/Summary'
import { Download } from './Pages/Download'
import { DetailPage } from './Pages/detailPage'
import { ChangeBranch } from './Pages/ChangeBranch'
import { isBranchStaff, isCollectionStaff, isSQDStaff } from './helpers/roles'
import { StaffReport } from './Pages/StaffReport'
import { PaymentDetail } from './Pages/PaymentDetail'
import { SQDReport } from './Pages/AgingReport/'
import ModalError from './component/modaldialog/ModalError'
import { CollectionReport } from './Pages/CollectionReport'

export default function App() {
  const dispatch = useDispatch()
  const loginData = useSelector((state: RootReducers) => state.loginReducer)

  useEffect(() => {
    dispatch(loginActions.handleReLogin(authService.checkSession()))
  }, [])

  const RequireAuth = ({ children }: any) => {
    if (authService.checkExpireSession()) {
      return <Navigate to="/login" />
    }
    return children
  }
  const RequireBranchStaffRole = ({ children }: any) => {
    if (isBranchStaff(loginData.account?.agentInfo.role as string)) {
      return children
    }
    return <Navigate to="/" />
  }

  const RequireCollection = ({ children }: any) => {
    if (isCollectionStaff(loginData.account?.agentInfo.role as string)) {
      return children
    }
    return <Navigate to="/" />
  }

  const RequireSQDRole = ({ children }: any) => {
    if (isSQDStaff(loginData.account?.agentInfo.role as string)) {
      return children
    }
    return <Navigate to="/" />
  }

  const RequireCollectionRole = ({ children }: any) => {
    if (isCollectionStaff(loginData.account?.agentInfo.role as string)) {
      return children
    }
    return <Navigate to="/" />
  }

  console.log(`NODE_ENV = ${window._env_.NODE_ENV}`)
  const TITLE = `eTR version: ${packageJson.version}.0`
  return (
    <>
      <Helmet>
        <title>{TITLE}</title>
        <meta
          name="Content-Security-Policy"
          content="default-src 'self'  https://*.fwd.co.th  https://*.ingest.sentry.io 'unsafe-inline'"
        />
      </Helmet>
      <Router>
        {/* <nav>
        <ul>
          <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/about">About</Link>
            </li> 
          <li>
            <Link to="/testDialog">test dialog</Link>
          </li>
        </ul>
      </nav> */}
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={
              <RequireAuth>
                <Dashboard />
              </RequireAuth>
            }
          />
          <Route
            path="/entryform"
            element={
              <RequireAuth>
                <EntryForm />
              </RequireAuth>
            }
          />
          <Route
            path="/summary"
            element={
              <RequireAuth>
                <Summary />
              </RequireAuth>
            }
          />

          <Route path="/health/alive" element={<Alive />}></Route>
          <Route path="/health/ready" element={<Ready />}></Route>
          <Route path="/ref/:id" element={<Download />}></Route>
          <Route
            path="/documentDetail/:id"
            element={
              <RequireAuth>
                <DetailPage />
              </RequireAuth>
            }
          ></Route>
          <Route
            path="/ChangeBranch"
            element={
              <RequireAuth>
                <RequireBranchStaffRole>
                  <ChangeBranch />
                </RequireBranchStaffRole>
              </RequireAuth>
            }
          ></Route>
          <Route
            path="/StaffReport"
            element={
              <RequireAuth>
                <RequireBranchStaffRole>
                  <StaffReport />
                </RequireBranchStaffRole>
              </RequireAuth>
            }
          ></Route>
          <Route
            path="/PaymentDetail"
            element={
              <RequireAuth>
                <RequireBranchStaffRole>
                  <PaymentDetail />
                </RequireBranchStaffRole>
              </RequireAuth>
            }
          ></Route>
          <Route
            path="/AgingReport"
            element={
              <RequireAuth>
                <RequireSQDRole>
                  <SQDReport />
                </RequireSQDRole>
              </RequireAuth>
            }
          ></Route>
          <Route
            path="/CollectionReport"
            element={
              <RequireAuth>
                <RequireCollectionRole>
                  <CollectionReport />
                </RequireCollectionRole>
              </RequireAuth>
            }
          ></Route>
          <Route path="/"></Route>
        </Routes>
      </Router>

      <ModalError />
    </>
  )
}
